// AppShell — top-level grid layout (sidebar + topbar + content).
// Phase 1: matches prototype's .bsp-app grid.
import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="bsp-app">
      <Sidebar />
      <div>
        <TopBar />
        <main className="bsp-content-wide">{children}</main>
      </div>
    </div>
  );
}
